import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function MockupSection() {
  const bullets = ['Acceso inmediato', 'Contenido 100% digital', 'Sistema paso a paso'];
  return <section className="relative w-full bg-[#0a0a0a] py-12 md:py-16 overflow-hidden" data-id="element-269">
      {/* Cinematic red glow backdrop */}
      <div className="absolute inset-0 z-0" data-id="element-270">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[800px] rounded-full bg-red-700/15 blur-[160px]" data-id="element-271" />
      </div>

      <div className="absolute top-0 left-0 right-0 h-16 bg-gradient-to-b from-black to-transparent z-10" data-id="element-272" />
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-black to-transparent z-10" data-id="element-273" />

      <div className="relative z-20 max-w-5xl mx-auto px-6" data-id="element-274">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center" data-id="element-275">
          {/* Title */}
          <div className="mb-8" data-id="element-276">
            <h2 className="font-display text-3xl md:text-5xl uppercase leading-[1.05] tracking-tight" data-id="element-277">
              <span className="text-white drop-shadow-[0_0_25px_rgba(220,38,38,0.4)]" data-id="element-278">
                La solución:
              </span>{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-b from-red-500 to-red-700 drop-shadow-[0_0_30px_rgba(220,38,38,0.8)]" data-id="element-279">
                Control Total
              </span>
            </h2>
          </div>

          {/* MOCKUP IMAGE */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.96
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2,
          duration: 1
        }} className="relative max-w-4xl mx-auto mb-8" data-id="element-280">
            <div className="absolute -inset-6 bg-red-600/20 rounded-3xl blur-[60px] opacity-60" data-id="element-281" />

            <div className="relative bg-black rounded-xl overflow-hidden border border-red-900/40 shadow-[0_0_50px_rgba(220,38,38,0.2)]" data-id="element-282">
              <img src="https://cdn.magicpatterns.com/uploads/nyEYJyypgV4QctySWo842u/ChatGPT_Image_8_jun_2026,_21_35_43.png" alt="Pack Control Total para hombres: 6 tomos y 6 bonos exclusivos" className="w-full h-auto block relative z-0" loading="lazy" decoding="async" data-id="element-283" />
              <div className="absolute inset-0 pointer-events-none bg-gradient-to-t from-black/40 via-transparent to-transparent z-[1]" data-id="element-284" />
            </div>
          </motion.div>

          {/* Bullets */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4,
          duration: 0.6
        }} className="flex flex-wrap justify-center gap-3 md:gap-6 mb-8" data-id="element-285">
            {bullets.map((bullet, index) => <div key={index} className="bg-black/60 border border-red-900/30 rounded-full px-4 py-2 flex items-center gap-2" data-id="element-286">
                <span className="text-red-500 text-sm" data-id="element-287">✔</span>
                <span className="text-gray-300 text-sm font-medium" data-id="element-288">
                  {bullet}
                </span>
              </div>)}
          </motion.div>

          {/* Direct CTA */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.6,
          duration: 0.6
        }} data-id="element-289">
            <a href="#checkout" className="group relative inline-block" data-id="element-290">
              <div className="absolute -inset-1 bg-red-600 rounded-xl blur-xl opacity-50 group-hover:opacity-80 transition-opacity duration-500" data-id="element-291" />
              <button className="relative flex items-center gap-3 bg-gradient-to-b from-red-600 to-red-800 text-white font-display text-lg md:text-xl uppercase tracking-wider px-8 py-4 rounded-xl border border-red-400/40 shadow-lg transition-all duration-300 hover:scale-[1.02] active:scale-[0.98]" data-id="element-292">
                <span data-id="element-293">QUIERO EL SISTEMA COMPLETO</span>
                <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" data-id="element-294" />
              </button>
            </a>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}